import request from '../utils/request'

export default {
  async list (data) {
    const ret = await request('/v1/scene/list', data,'POST')
    return ret
  },
  async save (data) {
    const ret = await request('/v1/scene/save', data,'POST')
    return ret
  },
  async delete (data) {
    const ret = await request('/v1/scene/delete', data,'POST')
    return ret
  }
}
